import { Injectable, inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { CustomerBaseData } from '@zero/shared/util-models';
import { Observable } from 'rxjs';
import { LoadContactData, LoadCustomerAccountData, LoadCustomerBaseData } from './customer.actions';
import { CustomerStateModule } from './customer.state';

@Injectable({ providedIn: 'root' })
export class CustomerStateFacade {
  readonly #store = inject(Store);

  public customerBaseData$ = this.#store.select(CustomerStateModule.customerBaseData);
  public get customerBaseData(): CustomerBaseData {
    return this.#store.selectSnapshot(CustomerStateModule.customerBaseData);
  }
  public accountData$ = this.#store.select(CustomerStateModule.accountData);
  public accountDataLoading$ = this.#store.select(CustomerStateModule.accountDataLoading);

  public customerAccountData$ = this.#store.select(CustomerStateModule.customerAccountData);

  public loadCustomerBaseData(force = false): Observable<void> {
    return this.#store.dispatch(new LoadCustomerBaseData({ force }));
  }

  public loadContactData(force = false): Observable<void> {
    return this.#store.dispatch(new LoadContactData({ force }));
  }

  public loadCustomerAccountData(force = false) {
    return this.#store.dispatch(new LoadCustomerAccountData({ force }));
  }
}
